import { authorizedApi } from './index';

export const currentUserApi = authorizedApi.injectEndpoints({
  endpoints: (builder) => ({
    getCurrentUser: builder.query({
      async queryFn(_, __, ___, baseQuery) {
        await baseQuery({
          url: '/auth/login',
          method: 'POST',
          credentials: 'include',
        });

        const user = await baseQuery({
          url: '/users/me',
          method: 'get',
        });

        return {
          data: {
            ...user.data,
          },
        };
      },
      async onQueryStarted(_, { dispatch }) {
        dispatch(
          currentUserApi.util.updateQueryData(
            'getCurrentUserProfile',
            undefined,
            (value) => {
              return value;
            },
          ),
        );
      },
    }),
    getCurrentUserRewards: builder.query({
      query: () => ({
        url: '/rewards/me',
        method: 'GET',
      }),
    }),
    getCurrentUserProfile: builder.query({
      query: () => '/users/me',
    }),
    getCurrentUserReferrals: builder.query({
      query: () => '/rewards/me/referrals',
    }),
    setReferral: builder.mutation({
      query: (referralCode) => ({
        url: '/users/referral',
        method: 'POST',
        body: { referralCode },
      }),
    }),
    completeOnboarding: builder.mutation({
      query: () => ({
        url: '/users/me/onboarding-completed',
        method: 'POST',
      }),
    }),
    setFirebaseToken: builder.mutation({
      query: (token) => ({
        url: '/firebase/token',
        method: 'POST',
        body: { token },
      }),
    }),
    testPushNotification: builder.mutation({
      query: (email) => ({
        url: '/admin/firebase/test',
        method: 'POST',
        body: { email },
      }),
    }),
    deleteAccount: builder.mutation({
      query: (reason) => ({
        url: '/users/delete-account',
        method: 'POST',
        body: { reason },
      }),
    }),
    setUtmData: builder.mutation({
      query: ({ utm_source, utm_medium, utm_campaign }) => ({
        url: '/users/me/utm-data',
        method: 'POST',
        body: { utm_source, utm_medium, utm_campaign },
      }),
    }),
  }),
});

export const {
  useGetCurrentUserQuery,
  useGetCurrentUserRewardsQuery,
  useGetCurrentUserProfileQuery,
  useSetReferralMutation,
  useSetFirebaseTokenMutation,
  useTestPushNotificationMutation,
  useLazyGetCurrentUserProfileQuery,
  useDeleteAccountMutation,
  useGetCurrentUserReferralsQuery,
  useCompleteOnboardingMutation,
  useSetUtmDataMutation,
} = currentUserApi;
